<template>
  <div style="margin: 0.8rem">
    <home-call
      v-for="(v, i) in callList"
      :key="i"
      :tilde="v.topic"
      :sub-tilde="v.briefIntroduction"
      :img="v.imgmin"
      :post-date="v.postDate"
      @click="toDetail(v)"
    />
    <my-btn :value="showPage ? '加载更多' : '没有更多'" @click="evenMore" />
  </div>
</template>

<script>
import homeCall from "../../common/homeCall";
import myBtn from "../../common/myBtn";
import service from "../../api/service";

export default {
  name: "search",
  data() {
    return {
      callList: [],
      pageIndex: 1,
      showPage: true,
    };
  },
  components: {
    homeCall,
    myBtn,
  },
  mounted() {
    this.queryNewsByKeywords(this.$route.query.value);
  },
  methods: {
    toDetail(row) {
      sessionStorage.setItem("row", JSON.stringify(row));
      this.$router.push({
        path: "/xwDetail",
        query: { sourcePath: "/home", contentId: row.contentid },
      });
    },
    queryNewsByKeywords(value) {
      service
        .get("/trafficXw/management", {
          page: this.pageIndex,
          size: 7,
          topic:value
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.length === 0) {
              this.showPage = false;
            }
            this.callList = this.callList.concat(res.data);
            console.warn(res.data)
          }
        });
    },
    evenMore() {
      this.pageIndex += 1;
      this.queryNewsByKeywords(this.$route.query.value);
    },
  },
};
</script>

<style scoped>
</style>